<fui-autocomplete-control
    [options]="data"
    [disabled]="isReadonly"
    [labelField]="labelField"
    [placeholder]="placeholder"
    [label]="label"
    (focussed$)="onFocus($event)"
    [valueField]="valueField"
    (filtered$)="filterResults($event)"
    [control]="formControl"
    (valueChange)="selected($event)"
    [showExtendedSearchOption]="extendedSearchComponent != undefined">
</fui-autocomplete-control>
